import { makeLabels } from 'utils/i18n';

const NAMESPACE = 'pages.cryptoPayout.events';

const LABELS = makeLabels(
  {
    HEADER: ['header', 'Payout Information'],
    INSTRUCTION: ['instruction', 'Customer can now scan this QR Code and continue on their personal device.'],
    LINK_LABEL: ['linkLabel', 'Payout Form'],
    ID_LABEL: ['idLabel', 'Payout ID'],
    KYC_STATUS_LABEL: ['kycStatusLabel', 'Customer Status'],
  },
  NAMESPACE,
);

export const KEYS = {
  QR_CODE_SIZE: 200,
};

export default LABELS;
